export default __webpack_public_path__ + "static/media/9.90d1c60d.jpg";